import React, { forwardRef, useState, useEffect } from "react"
import BootstrapTable from "react-bootstrap-table-next"
import { shallowEqual, useSelector } from "react-redux"
import { sortCaret } from "../../../../../_metronic/_helpers"
import ToolkitProvider from "react-bootstrap-table2-toolkit"

const CurrentContactTracingTableToPrint = forwardRef((props, ref) => {
	//changed for current page to print
	const { rowsToUse, columnVisibilityModel, currentTablePageInfo } = props

	const { currentCustomer, companies } = useSelector(
		state => ({
			currentCustomer: state.profile?.currentCustomer,
			companies: state.profile?.currentCustomer?.vendors || []
		}),
		shallowEqual
	)

	const [tableData, setTableData] = useState([])
	const [dynamicColumns, setDynamicColumns] = useState([])

	//changed for current page to print
	useEffect(() => {
		if (!rowsToUse || !currentTablePageInfo) return
		const filteredDisabled = rowsToUse
			.filter(val => !val.disabled)
			.filter(val => val?.assetDetails?.name.trim() !== "")
		setTableData(
			filteredDisabled.slice(
				currentTablePageInfo?.page * currentTablePageInfo?.pageSize,
				(currentTablePageInfo?.page + 1) * currentTablePageInfo?.pageSize
			)
		) //data from current page and page size
	}, [rowsToUse, currentTablePageInfo])

	useEffect(() => {
		if (!columnVisibilityModel) return

		const realDynamicColumns =
			columns &&
			columns.filter(column => {
				// If columnVisibilityModel exists and has a corresponding entry
				if (
					columnVisibilityModel &&
					Object.prototype.hasOwnProperty.call(columnVisibilityModel, column?.dataField)
				) {
					// Include the column if the value is not false
					return columnVisibilityModel[column?.dataField] !== false
				}
				// Include the column if it doesn't exist in columnVisibilityModel
				return true
			})

		realDynamicColumns && realDynamicColumns.length > 0 && setDynamicColumns(realDynamicColumns)
	}, [columnVisibilityModel])

	const columns = [
		{
			dataField: "date",
			text: "Date",
			sort: true,
			sortCaret: sortCaret,
			style: {
				verticalAlign: "middle",
				minWidth: "80px"
			}
		},
		{
			dataField: "area",
			text: "Area",
			sort: true,
			sortCaret: sortCaret,
			style: {
				verticalAlign: "middle",
				minWidth: "80px"
			}
		},
		{
			dataField: "time",
			text: "Time",
			sort: true,
			formatter: cell => {
				return cell
					? `0${(cell / 60) ^ 0}`.slice(-2) + "h " + ("0" + (cell % 60)).slice(-2) + "m"
					: ""
			},
			style: {
				verticalAlign: "middle",
				minWidth: "80px"
			}
		}
	]

	return (
		<>
			<ToolkitProvider
				search
				wrapperClasses="table-responsive"
				classes="table table-head-custom table-vertical-center"
				bootstrap4
				keyField="id"
				//changed and added for data grid
				// data={assets || []}
				// columns={columns}
				data={tableData && tableData.length > 0 ? tableData : []}
				columns={dynamicColumns && dynamicColumns.length > 0 ? dynamicColumns : columns}
				style={{ overflow: "hidden" }}
			>
				{props => (
					<div ref={ref}>
						<div
							className="d-flex justify-content-between align-items-baseline"
							style={{ marginBottom: "2rem" }}
						>
							<div>
								<h3>
									{currentCustomer && currentCustomer?.customerInfo?.name && (
										<span>{currentCustomer?.customerInfo?.name}</span>
									)}{" "}
									assets
								</h3>
							</div>
							<div style={{ width: "10rem", height: "auto", marginRight: "2rem" }}>
								<img
									src="/media/logos/crowdkeep.png"
									alt="company logo"
									style={{ width: "100%", height: "100%", objectFit: "contain" }}
								/>
							</div>
						</div>
						<div style={{ width: "100%", height: "100%" }}>
							<BootstrapTable bordered={false} {...props.baseProps}></BootstrapTable>
						</div>
					</div>
				)}
			</ToolkitProvider>
		</>
	)
})

export default CurrentContactTracingTableToPrint
